import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { DashboardFoldersComponent } from './components/dashboard-folders/dashboard-folders.component';
import { FolderInfoComponent } from './components/folder-info/folder-info.component';
import { DashboardComponent } from './containers/dashboard/dashboard.component';
import { DashboardFoldersV3Component } from './components/dashboard-folders-v3/dashboard-folders-v3.component';
import { DashboardFoldersWrapperComponent } from './components/dashboard-folders/dashboard-folders-wrapper.component';
var DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
    wheelPropagation: true
};
export var COMPONENTS = [
    DashboardComponent,
    FolderInfoComponent,
    DashboardFoldersComponent,
    DashboardFoldersV3Component,
    DashboardFoldersWrapperComponent
];
var ɵ0 = DEFAULT_PERFECT_SCROLLBAR_CONFIG;
var DashboardModule = /** @class */ (function () {
    function DashboardModule() {
    }
    return DashboardModule;
}());
export { DashboardModule };
export { ɵ0 };
